module.exports = __webpack_public_path__ + "static/media/img_15.aa259f03.JPG";